import { createSlice } from '@reduxjs/toolkit';

const initialUserData = {
  allowedPaths: {},
};

export const pathsSlice = createSlice({
  name: 'user',
  initialState: initialUserData,
  reducers: {
    updateAllowedPath: (state, action) => {
      state.allowedPaths[action.payload.path] = action.payload.isAllowed;
    },
    removeAllPaths: (state) => {
      state.allowedPaths = {};
    },
  },
});

export const { updateAllowedPath, removeAllPaths } = pathsSlice.actions;

export default pathsSlice.reducer;
